import { MeterState } from './types';

const state = (): MeterState => {
  return {
    meters: [],
  };
};

export default state;
